import styles from './css/Login.css';

import React from 'react';
import { Link } from 'react-router';
import { Button, Checkbox, Icon, TextInput } from '@tcc/crate';
import { getMessage } from '../../i18n/i18nWrapper';
import PropTypes from 'prop-types';

export const Login = ({
  errorText,
  hasSelectedStayLoggedIn,
  isLoginFetching,
  login,
  onClickRegistration,
  onClickResetPassword,
  password,
  setPassword,
  setUsername,
  toggleHasSelectedStayLoggedIn,
  username
}) => {

  function formLogin(e) {
    e.preventDefault();
    login();
  }

  /* If I have an error, show username-specific errors under username text input and all other
     errors under password which doubles as a space to show error messages applying to both inputs,
     e.g. "invalid username/password combination" */
  const showErrorTextUnderUser = errorText.includes('Username') && !errorText.includes('Password');
  const errorMsg = errorText.length ? getMessage('login.error.' + errorText) : null;
  const usernameError = showErrorTextUnderUser ? errorMsg : null;
  const passwordError = showErrorTextUnderUser ? null : errorMsg;

  return (
    <div className={`${styles.mainContainer} ${styles.container}`}>
      <div className={styles.card}>
        <div className={styles.container}>

          <div className={styles.logoContainer} data-test-id="climate-fv-logo">
            <Icon className={styles.logo} glyph={Icon.set.CLIMATE_PORTAL_COLOR} />
          </div>

          <p className={styles.title} data-test-id="login-title">
            {getMessage('login.login')}
          </p>

          <form className={styles.loginForm} onSubmit={formLogin}>
            <TextInput
              error={usernameError}
              id="login-username-text-input"
              label={getMessage('login.username')}
              name="username"
              onChange={setUsername}
              testId="username"
              value={username} />

            <TextInput
              error={passwordError}
              label={getMessage('login.password')}
              name="password"
              onChange={setPassword}
              showReset={false}
              testId="password"
              type="password"
              value={password} />

            <div className={styles.checkboxContainer}>
              <Checkbox
                checked={hasSelectedStayLoggedIn}
                label={getMessage('login.staySignedIn')}
                onChange={toggleHasSelectedStayLoggedIn}
                testId="stay-signed-in" />
            </div>

            <div>
              <Button
                className={styles.button}
                isLoading={isLoginFetching}
                mode="primary"
                testId="log-in"
                type="submit">
                {getMessage('login.login')}
              </Button>
            </div>
          </form>
          <div>
            <Link
              className={styles.link}
              data-test-id="forgot-password"
              href={`${window.location.pathname}#/reset_password`}
              onClick={onClickResetPassword}>
              {getMessage('login.forgotPassword')}
            </Link>
          </div>

        </div>
      </div>

      <div className={styles.divider} />

      <div className={styles.lowerContainer}>
        <p className={styles.accountQuestion}>{getMessage('login.noAccount')}</p>

        <Link
          className={styles.link}
          data-test-id="create-account"
          href={`${window.location.pathname}#/register`}
          onClick={onClickRegistration}>
          {getMessage('login.createAccount')}
        </Link>

      </div>
    </div>
  );
};

Login.propTypes = {

  // Error text in response to an unsuccessfully login attempt
  errorText: PropTypes.string,

  // Boolean that determines whether the user has selected the "Stay Logged In" checkbox or not
  hasSelectedStayLoggedIn: PropTypes.bool.isRequired,

  // Boolean that determines if the request to login is in progress
  isLoginFetching: PropTypes.bool.isRequired,

  // User calls login API call
  login: PropTypes.func.isRequired,

  // Analytics hook to track clicking the registration link from login
  onClickRegistration: PropTypes.func.isRequired,

  // Analytics hook to track clicking the reset password link from login
  onClickResetPassword: PropTypes.func.isRequired,

  // User's inputed password
  password: PropTypes.string.isRequired,

  // Password's textinput's onChange function
  setPassword: PropTypes.func.isRequired,

  // Username's textinput's onChange function
  setUsername: PropTypes.func.isRequired,

  // Click handler that toggles the hasSelectedStayLoggedIn bool
  toggleHasSelectedStayLoggedIn: PropTypes.func.isRequired,

  // User's inputed username
  username: PropTypes.string.isRequired

};

export default Login;
